import { useAuth } from '@/context/AuthContext';
import { ShieldAlert } from 'lucide-react';

/**
 * PermGuard - protezione route lato client.
 * Se l'utente non ha il permesso `view` sulla sezione, mostra "Accesso negato"
 * invece di renderizzare `children`. Super-admin bypass.
 *
 * Uso:
 *   <PermGuard section="fatture_emesse"><FattureUscitaPage /></PermGuard>
 */
export default function PermGuard({ section, children, fallback = null }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.is_super_admin) return children;
  const perms = user.permissions || {};
  // Legacy admin senza permessi salvati → passa
  if (!perms[section]) return children;
  if (perms[section]?.view) return children;
  if (fallback) return fallback;
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6" data-testid="perm-denied">
      <ShieldAlert className="h-16 w-16 text-red-400 mb-4" />
      <h1 className="text-2xl font-bold text-slate-900 mb-2">Accesso negato</h1>
      <p className="text-sm text-slate-600 max-w-md">
        Non hai il permesso di visualizzare questa sezione. Contatta un amministratore se pensi sia un errore.
      </p>
      <p className="text-xs text-slate-400 mt-4 font-mono">Sezione richiesta: <strong>{section}</strong></p>
    </div>
  );
}
